// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
}

.title {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
}

.challenge {
  text-align: center;
  font-size: 18px;
  color: #333;
}

.challenge-image {
  width: 45%;
  object-fit: cover;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

.main-image {
  width: 75%;
  object-fit: cover;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

.card {
  margin: auto; /* 카드 사이의 여백을 조정 */
  border: 1px solid #e0e0e0; /* 카드 테두리 추가 */
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1); /* 그림자 효과 추가 */
}

.card-content {
  padding: 10px; /* 내용에 패딩 추가 */
}

.card-title {
  font-size: 1.2em; /* 제목 폰트 크기 조정 */
  margin-bottom: 5px; /* 제목 아래 여백 추가 */
}

.card-description {
  font-size: 0.9em; /* 설명 텍스트 폰트 크기 조정 */
  color: #555; /* 설명 텍스트 색상 조정 */
}

.card-icon {
  max-width: 128px;
  max-height: 128px;
  width: auto; /* 아이콘 너비를 카드 너비에 맞춤 */
  height: auto; /* 아이콘 높이를 자동으로 조정 */
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.item-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.item-card {
  width: calc(25% - 10px);
  box-sizing: border-box;
  text-align: center;
}

.tier-title{
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY,EAAE,kBAAkB;EAChC,yBAAyB,EAAE,cAAc;EACzC,0CAA0C,EAAE,cAAc;AAC5D;;AAEA;EACE,aAAa,EAAE,cAAc;AAC/B;;AAEA;EACE,gBAAgB,EAAE,gBAAgB;EAClC,kBAAkB,EAAE,gBAAgB;AACtC;;AAEA;EACE,gBAAgB,EAAE,oBAAoB;EACtC,WAAW,EAAE,iBAAiB;AAChC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW,EAAE,sBAAsB;EACnC,YAAY,EAAE,oBAAoB;EAClC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".App {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.container {\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.title {\r\n  text-align: center;\r\n  font-size: 24px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.challenge {\r\n  text-align: center;\r\n  font-size: 18px;\r\n  color: #333;\r\n}\r\n\r\n.challenge-image {\r\n  width: 45%;\r\n  object-fit: cover;\r\n  margin: 0 auto;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.main-image {\r\n  width: 75%;\r\n  object-fit: cover;\r\n  margin: 0 auto;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.card {\r\n  margin: auto; /* 카드 사이의 여백을 조정 */\r\n  border: 1px solid #e0e0e0; /* 카드 테두리 추가 */\r\n  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1); /* 그림자 효과 추가 */\r\n}\r\n\r\n.card-content {\r\n  padding: 10px; /* 내용에 패딩 추가 */\r\n}\r\n\r\n.card-title {\r\n  font-size: 1.2em; /* 제목 폰트 크기 조정 */\r\n  margin-bottom: 5px; /* 제목 아래 여백 추가 */\r\n}\r\n\r\n.card-description {\r\n  font-size: 0.9em; /* 설명 텍스트 폰트 크기 조정 */\r\n  color: #555; /* 설명 텍스트 색상 조정 */\r\n}\r\n\r\n.card-icon {\r\n  max-width: 128px;\r\n  max-height: 128px;\r\n  width: auto; /* 아이콘 너비를 카드 너비에 맞춤 */\r\n  height: auto; /* 아이콘 높이를 자동으로 조정 */\r\n  display: block;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.item-grid {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-around;\r\n}\r\n\r\n.item-card {\r\n  width: calc(25% - 10px);\r\n  box-sizing: border-box;\r\n  text-align: center;\r\n}\r\n\r\n.tier-title{\r\n  text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
